import { Form } from "react-bootstrap";

const PreAssessmentQuestions = props => {
  const questionsArr = props?.questions;
  const answers = props?.answers;
  const isSubmitted = props?.isSubmitted; // ✅ NEW

  const saveAnswer = (val, ques_id) => {
    if (isSubmitted) return; // 🔒 BLOCK changes after submit

    let allAnswers = props?.answers || {};
    allAnswers = {
      ...allAnswers,
      [ques_id]: val,
    };
    props.setAnswers(allAnswers);
  };

  return (
    <>
      <h3 className="text-center mb-3">Pre Assessment Questions</h3>

      {questionsArr &&
        questionsArr.map((el, index) => {
          const questionKey = el.question_id ?? index;

          return (
            <div key={questionKey} className="pre-assement-card mb-3">
              {/* TEXT TYPE */}
              {el?.option_type === "text" && (
                <Form.Group className="col-lg-12">
                  <div className="form-group">
                    <Form.Label className="float-label">
                      {index + 1}. {el?.question}*
                    </Form.Label>

                    <Form.Control
                      type="text"
                      placeholder="Enter your Answer"
                      value={answers?.[questionKey] || ""}
                      disabled={isSubmitted} // 🔒 LOCK
                      onChange={e => saveAnswer(e.target.value, questionKey)}
                    />
                  </div>
                </Form.Group>
              )}

              {/* MCQ TYPE */}
              {el?.option_type === "mcq" && (
                <Form.Group className="col-lg-12">
                  <div className="form-group">
                    <Form.Label className="float-label">
                      {index + 1}. {el?.question}*
                    </Form.Label>

                    <div className="question-cards">
                      {[el.option1, el.option2, el.option3, el.option4]
                        .filter(Boolean)
                        .map((opt, i) => (
                          <div className="d-flex gap-3" key={i}>
                            <Form.Check
                              id={`q${questionKey}-opt${i}`}
                              name={`question-${questionKey}`}
                              type="radio"
                              checked={answers?.[questionKey] === opt}
                              disabled={isSubmitted} // 🔒 LOCK
                              onChange={() => saveAnswer(opt, questionKey)}
                              className="custom-checkbox lso"
                            />
                            {opt}
                          </div>
                        ))}
                    </div>
                  </div>
                </Form.Group>
              )}
            </div>
          );
        })}
    </>
  );
};

export default PreAssessmentQuestions;
